import React from 'react';

import Combobox from './primitives/Combobox';
import { t } from '../l10n/l10n';
import Locations from '../../../views/Locations';
import { Location } from '../../../../types/internal-api';

export default function LocationCombobox(props) {
    return (
        <Combobox
            {...props}
            aria-label={t`FORM_LOCATION_HEADLINE`}
            endpoint="/inventory/locations"
            transform={(Locations: Location[]) =>
                Locations.map(Location => ({
                    data: Location,
                    text: `${Location.number} - ${Location.name}`,
                    summary: Location.name,
                    value: Location.number,
                }))
            }
            modal={({ hide, onChange }) => (
                <Locations
                    onCreated={(Location: Location) => {
                        onChange(Location.number, Location, true);
                        hide();
                    }}
                    onSelected={(Location: Location) => {
                        onChange(Location.number, Location);
                        hide();
                    }}
                />
            )}
            modalSize="sm"
        />
    );
}
